import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { ChiefComplaintModel } from './system-bot.model';

@Component({
    selector: 'app-system-bot',
    templateUrl: './system-bot.component.html',
    styleUrls: ['./system-bot.component.scss'],
    standalone: false
})
export class SystemBotComponent extends MainComponent implements OnInit {

  // fg: FormGroup;
  fg = new FormGroup({
    cdss_name: new FormControl(),
    facility_id: new FormControl(''),
    remarks: new FormControl(''),
    transaction: new FormArray([
      new FormGroup({})
    ]),
    chief_complaints: new FormControl(),
    cdss_tags: new FormControl([])
  })
  controls: any[] = [];
  chiefcomplaint: ChiefComplaintModel;
  result: any = {};
  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    super(injector, route);
  }

  ngOnInit(): void {
    this.baseService.setTitle("pagename.cdss_master");
    this.baseService.backNavigation = true;
    this.chiefcomplaint = new ChiefComplaintModel();
    this.formService.setEditableGrid(true);
    this.baseService.getResourceDef('cdss_master', res => {
      this.result.fields = res.form.blocks[0].fields;
      let group = this.processFields();
      this.fg = new FormGroup({
        cdss_name: new FormControl(),
        facility_id: new FormControl(''),
        remarks: new FormControl(''),
        transaction: new FormArray([
          new FormGroup(group)
        ]),
        chief_complaints: new FormControl(),
        cdss_tags: new FormControl([])
      });
      if (this.route.snapshot.params && this.route.snapshot.params.action && this.route.snapshot.params.id && (this.route.snapshot.params.action == 'modify' || this.route.snapshot.params.action == 'view')) {
        this.loader.showSpinner();
        this.baseService.getById(this.route.snapshot.params.id, 'cdss_master', 'facility-management').subscribe(
          (data: any) => {
            if (data.errCode == -1) {
              this.alerts.error(data.message);
            } else {
              this.result.cdssValues = data;
              this.fg.controls['cdss_name'].setValue(data.cdss_name);
              this.fg.controls['chief_complaints'].setValue(data.chief_complaints);
              this.fg.controls['remarks'].setValue(data.remarks);
              this.loader.showSpinner();
              // setTimeout(() => {
                this.createQuestions(data.transaction);
                // this.fg.controls['transaction'].patchValue(data.transaction);
              // },4000);
            }
            this.loader.hideSpinner();
          }, error => {
            console.log(error);
            this.alerts.error('API error');
            this.loader.hideSpinner();
          }
        )
      } 
    })
  }

  listResource(){
    this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
  }

  ngAfterViewInit() {
    if (this.appService.getOrganization()) {
      var orgId = this.appService.getOrganization();
      if (orgId && orgId.org_id)
        this.fg.controls.facility_id.setValue(orgId.org_id);
    }
    if (this.result.cdssValues) {
      // setTimeout(() => {
        this.fg.controls.chief_complaints.setValue(this.result.cdssValues.chief_complaints);
      // });
    }
    this.showId('acc0');
    if (this.route.snapshot.params && this.route.snapshot.params.action && this.route.snapshot.params.id && this.route.snapshot.params.action == 'view') {
      this.fg.disable();
    }
  }
  getRows() {
    return this.fg.get('transaction') as FormArray;
  }
  addArray(parentId, parentText, answerText) {
    let group = this.processFields(parentId, parentText, answerText);
    (<FormArray>this.fg.get('transaction')).push(new FormGroup(group))
    this.cdRef.detectChanges();
  }
  removeArray(index) {
    this.controls.splice(index, 1);
    (<FormArray>this.fg.get('transaction')).removeAt(index);
    this.cdRef.detectChanges();
  }
  createQuestions(transaction) {
    if (transaction && transaction.length > 0) {
      for (var i = 0; i < transaction.length; i++) {
        let parentText = ''
        if (transaction[i].parent_id != '') {
          let pText = transaction.find(val => {
            return (val.question_code == transaction[i].parent_id);
          });
          if (pText && pText != undefined) {
            parentText = pText.question_text;
          }
        }
        let group = this.multipleFields(transaction[i], parentText);
        (<FormArray>this.fg.get('transaction')).push(new FormGroup(group));
      }
    }
  }
  multipleFields(trans, pText) {
    // console.log("transaction is ", transaction);
    let transaction = JSON.parse(JSON.stringify(trans))
    let group = {};
    let fields_ = JSON.parse(JSON.stringify(this.result.fields));
    let questions = this.formService.buildQuestions(fields_);
    questions.forEach(q => {
      if (q.key == 'parent_text') {
        group[q.key] = new FormControl(pText);
      } else {
        group[q.key] = new FormControl(transaction[q.key]);
      }
      group[q.key].question_component = { question: q }
      if (q.key == 'answers' && transaction.type == 'question') {
        group[q.key].question_component.question.datasource = { possible_value: transaction.answers };
      } else if (q.key == 'orderset' && transaction.type == 'orderset') {
        if (group['orderset']) 
          group['orderset'].question_component.question.visible = true;
        if(group['recommend'])
          group['recommend'].question_component.question.visible = false;
        if (group['answers'])
          group['answers'].question_component.question.visible = false;
        if (group['question_text'])
          group['question_text'].question_component.question.visible = false;
      }else if (q.key == 'recommend' && transaction.type == 'recommendation') {
        if (group['orderset']) 
          group['orderset'].question_component.question.visible = false;
        if(group['recommend'])
          group['recommend'].question_component.question.visible = true;
        if (group['answers'])
          group['answers'].question_component.question.visible = false;
        if (group['question_text'])
          group['question_text'].question_component.question.visible = false;
      }
      if(this.route.snapshot.params.action && this.route.snapshot.params.action == 'view'){
        group[q.key].question_component.question.disabled = true;
      }
    })
    this.controls.push(questions);
    return group;
  }

  processFields(parentId?, parentText?, answerText?) {
    let group = {};
    let fields_ = JSON.parse(JSON.stringify(this.result.fields));
    let questions = this.formService.buildQuestions(fields_);
    questions.forEach(q => {
      if (q.key == 'type') {
        group[q.key] = new FormControl('question');
      } else if (q.key == 'parent_id') {
        group[q.key] = new FormControl('');
        group[q.key].value = parentId != undefined ? parentId : '';
      } else if (q.key == 'parent_text') {
        group[q.key] = new FormControl('');
        group[q.key].value = parentText != undefined ? parentText : '';
      } else if (q.key == 'answer_text' || q.key == 'answer_code') {
        group[q.key] = new FormControl('');
        if (answerText && answerText.length > 0) {
          let text = answerText[answerText.length - 1];
          if (q.key == 'answer_text')
            group['answer_text'].value = text != undefined && text.text ? text.text : '';
          if (q.key == 'answer_code')
            group['answer_code'].value = text != undefined && text.id ? text.id : '';
        }
      } else {
        group[q.key] = new FormControl('')
      }
      group[q.key].question_component = { question: q }
    })
    this.controls.push(questions);
    return group;
  }

  onValueChanged(event, group, i, row) {
    // Changing option of answer dropdown on basis of question dropdown value
    if (event.question.key == 'question_text' && (event.val != '' || event.text != '') && row.controls.question_text.question_component && row.controls.question_text.question_component.form._manualChange) {
      row.controls.orderset.setValue([]);
      if ((event.val && row.controls.question_code.value != '' && row.controls.question_code.value != undefined && event.val.code && row.controls.question_code.value != event.val.code) || event.val == '') {
        const dialogRef = this.modalService.confirm('Are you sure you want to change question ?', 'All Questions and orderset will be deleted related to particular question');
        dialogRef.subscribe(result => {
          if (result) {
            let previous_answer = row.controls.answers.value;
            if (previous_answer && previous_answer.length > 0)
              this.findAnswer(previous_answer);
            row.controls.answers.setValue([]);
            row.controls.question_code.setValue('');
            row.controls.answers.question_component.question.datasource = {}
            if (event.val) {
              row.controls.answers.question_component.question.datasource = { possible_value: event.val.answers };
              row.controls.question_code.setValue(event.val.code);
            }
          } else {
            if (event.val == '' && row.controls.question_text && row.controls.question_text.question_component && row.controls.question_text.question_component.question && row.controls.question_text.question_component.question.options) {
              let x = row.controls.question_code.value.split('__')
              row.controls.question_text.question_component.form._manualChange = false;
              let j = row.controls.question_text.question_component.question.options.find(val => {
                return (val.code == x[0]);
              });
              if (j && j.text)
                row.controls.question_text.setValue(j.text);
            }
          }
        },
          () => { });
      }
      // else if (this.fg.getRawValue().transaction.filter(elem => (elem.question_text == event.val.text)).length > 1) {
      //   this.alerts.error('Question already selected');
      //   row.controls.question_text.setValue('');
      // }
      else {
        row.controls.answers.question_component.question.datasource = { possible_value: event.val.answers };
        row.controls.question_code.setValue(event.val.code + '__' + i);
      }
    } else if (event.question.key == 'type') {
      let status;
      status = event.val == 'orderset' || event.val == 'recommendation' ? false : true;
      row.controls.answers.question_component.question.visible = status;
      row.controls.question_text.question_component.question.visible = status;
      if ( event.val == 'orderset' && row.controls.orderset.question_component.question){
        if(row.controls.answers.value && row.controls.answers.value.length >0){
          row.controls.answers.setValue([]);
          this.removeAnswer(event,row);
        }
        if(row.controls.question_text.value != '' || row.controls.question_text.value != undefined){
          row.controls.question_text.setValue("");
          row.controls.question_code.setValue("");
        }
        row.controls.orderset.question_component.question.visible = !status;
        row.controls.recommend.question_component.question.visible = status;
      }else if ( event.val == 'recommendation' && row.controls.orderset.question_component.question){
        if(row.controls.answers.value && row.controls.answers.value.length >0){
          row.controls.answers.setValue([]);
          this.removeAnswer(event,row);
        }
        if(row.controls.question_text.value != '' || row.controls.question_text.value != undefined){
          row.controls.question_text.setValue("");
          row.controls.question_code.setValue("");
        }
        row.controls.orderset.setValue([]);
        row.controls.orderset.question_component.question.visible = status;
        row.controls.recommend.question_component.question.visible = !status;
      }else if ( event.val == 'question' && row.controls.orderset.question_component.question){
        row.controls.orderset.question_component.question.visible = !status;
        row.controls.recommend.question_component.question.visible = !status;
      }
    } else if (event.question.key == 'answers' && row.controls.answers.question_component) {
      this.removeAnswer(event,row);
    }
  }

  removeAnswer(event, row){
    let obj = this.fg.getRawValue();
    if (obj && obj.transaction && obj.transaction.length > 1) { // this is done if answer is deleted
      let arr = obj.transaction.filter(e => row.controls.question_code.value == e['parent_id']);
      if (arr && arr.length > 0) {
        var result = arr.filter(function (o1) {
          return !row.value.answers.some(function (o2) {
            return o1['answer_code'] === o2.id;
          });
        });
        console.log("result is ", result);
      }
      if (result && result.length > 0) {
        this.removingResults(result);
      } else {
        this.addArray(row.value.question_code, row.value.question_text, event.val);
      }
    } else {
      this.addArray(row.value.question_code, row.value.question_text, event.val);
    }
  }
  removingResults(result) {
    for (var j = 0; j < result.length; j++) {
      this.removeField(result[j]);
      if (result[j].answers && result[j].answers.length > 0) {
        this.findAnswer(result[j].answers);
      }
    }
  }
  findAnswer(answer) {
    let obj = this.fg.getRawValue();
    for (var i = 0; i < answer.length; i++) {
      let arr = obj.transaction.filter(e => e['answer_code'] == answer[i].id);
      this.removingResults(arr);
    }
  }
  removeField(result) {
    let obj = this.fg.getRawValue();
    let checkfield = result.answer_code ? result.answer_code : result.id;
    let index = obj.transaction.findIndex(x => x['answer_code'] === checkfield);
    if (index > 0)
      this.removeArray(index);
  }
  // answerSelected(index, row, pill) {
  //   if (pill.disabled == undefined || !pill.disabled) {
  //     (<FormArray>this.fg.get('transaction'))
  //       .controls
  //       .forEach(control => {
  //         control.disable();
  //         for (let field in control['controls']) {
  //           if (control['controls'][field]['question_component'].question) {
  //             control['controls'][field]['question_component'].question.disable = true;
  //             control['controls'][field]['question_component'].question.disabled = true;
  //           }
  //         }
  //       })
  //     this.addArray(row.value.question_code, row.value.question_text, pill.text);
  //   }
  // }

  onSubmit() {
    this.loader.showSpinner();
    let obj = this.fg.getRawValue();
    console.log("shdhjdsj ", obj);
    let flag = false;
    if (this.route.snapshot.params && this.route.snapshot.params.action && this.route.snapshot.params.action == 'modify') {
      if(obj.transaction[0]['type'] == 'question' && obj.transaction[0]['question_code'] == ''){
        obj['id'] = this.result.cdssValues.id;
        obj.transaction = obj.transaction.splice(1);
      }
    }
    if (obj.cdss_name == '' || obj.cdss_name == undefined) {
      this.alerts.error("Please add CDSS name");
      this.loader.hideSpinner();
      flag = false;
    } else if (obj.chief_complaints && obj.chief_complaints.length <= 0) {
      this.alerts.error("Please add Chief Complaints");
      this.loader.hideSpinner();
      flag = false;
    } else if (obj.transaction && obj.transaction.length > 0) {
      for (var i = 0; i < obj.transaction.length; i++) {
        if (obj.transaction[i]['type'] == 'question' && obj.transaction[i]['question_code'] == '') {
          this.alerts.error("Please add question or orderset");
          this.loader.hideSpinner();
          flag = false;
          return;
        } else if (obj.transaction[i]['type'] == 'question' && obj.transaction[i]['question_code'] != '' && obj.transaction[i]['answers'].length <= 0) {
          this.alerts.error("Please add answers of question");
          this.loader.hideSpinner();
          flag = false;
          return;
        } else if (obj.transaction[i]['type'] == 'orderset' && (obj.transaction[i]['orderset'] == '' || obj.transaction[i]['orderset'] == null)) {
          this.alerts.error("Please add orderset");
          this.loader.hideSpinner();
          flag = false;
          return;
        } else if (obj.transaction[i]['type'] == 'recommendation' && (obj.transaction[i]['recommend'] == '' || obj.transaction[i]['recommend'] == null)) {
          this.alerts.error("Please add recommendation");
          this.loader.hideSpinner();
          flag = false;
          return;
        } else {
          flag = true;
        }
      }
    } else {
      flag = true;
    }
    console.log("Flag is ", flag);
    if (flag) {
      let action: any;
      if (this.route.snapshot.params && this.route.snapshot.params.action && this.route.snapshot.params.action == 'modify') {
        action = 'MODIFY';
      }else{
        action = 'ADD';
      }
      this.baseService.action(obj, action, 'facility-management', 'cdss_master').subscribe(res => {
        console.log("Resource ", res);
        if (res.errCode == 0) {
          this.alerts.success('Request Successful');
          this.router.navigate(['facility-management/cdss_master/list']);
        } else
          this.alerts.error(res.message);
        this.loader.hideSpinner();
      })
    }
  }
  showId(id) {
    if (document.getElementById(id) && document.getElementById(id).style.display === "block") {
      document.getElementById(id).style.display = "none";
    }
    else if (document.getElementById(id) && document.getElementById(id).style.display === "none" || document.getElementById(id).style.display === "") {
      document.getElementById(id).style.display = "block";
    }
  }
}